module.exports = typeof window == 'object' && typeof Deno != 'object';



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/engine-is-browser.js
// module id = 303
// module chunks = 0 1